webpackJsonp([1],{

/***/ "/o5o":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__ = __webpack_require__("Aqhm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67567d5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__ = __webpack_require__("qrmn");
function injectStyle (ssrContext) {
  __webpack_require__("imYJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67567d5b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67567d5b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Modal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/oiM":
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "5asW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  update: function update(data) {
    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post('https://9pt0wza7da.execute-api.us-east-1.amazonaws.com/development/gallery', {
      data: data
    });
  }
});

/***/ }),

/***/ "82Oe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Piece_vue__ = __webpack_require__("vrgC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_266bf5c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Piece_vue__ = __webpack_require__("KRro");
function injectStyle (ssrContext) {
  __webpack_require__("TfjL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-266bf5c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Piece_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_266bf5c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Piece_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9CZf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Aaqe":
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQIAHAAcAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCACHAIoDAREAAhEBAxEB/8QAHQAAAgIDAQEBAAAAAAAAAAAABAUDBgECBwgACf/EADsQAAIBAgQFAgMGBQQBBQAAAAECAwQRAAUSIQYTMUFRImEHFHEjMoGRobEVQlLB8Bdi0eEWJDNUk/H/xAAaAQACAwEBAAAAAAAAAAAAAAACAwABBAUG/8QALhEAAgICAgEDBAEDBAMAAAAAAQIAEQMhEjEEEyJBBTJRYRRxgZEVI0KxJFLB/9oADAMBAAIRAxEAPwASf47VJHqE0igdST+e+PIY0zlqKzr5MeMgkNI/9c2ueXE2nzp640jI6+3jMowo3TSR/jbTtGIpKqSnDC+pRbra9vGGN5IQgFbgr45e6aF/635Y6CBKiRltdjp2thi+aqCwkP8A098q/dJ6f4tUMaSpTVriJrabNuu99rnbAn6gb+yRfpeUaLCOqb4vUssTRrWkOfTr5p9G/wBcZn+p2RSxi/SnHZjOn+IsNNVyE5jIqutzEx2Pk7HBL9Tx/wDISj9LykaMttH8SaGqSKnWeGdJYwQC99O3cg3ws+eGc11K/gZAv7Ea0nHeVKeW0MUci208s7kdtziDycWIgwR4+ZxDabjmCOa7RxsJCCHDBdINrEkY6ePP4+Ud7mXhlQ1IU+K+bUmYyPPlsyUiyLHHJG3NVdzqa4JvcW27YfjRL0YhvIddESy03xjqMurxQxwSyxOTIJJFN1vbYdSRt7b4aoQCyYv+SxPUsOWfGKonlKfIsoMZnDSTaD1sENri9t/0wYZFGjDOQ/iNIfi7BNIuuIqFsgZ32APRh7X2336YqwejCTJ+obF8TnYB1qY2V7MDzCAB0wrmQe43lqHw/E2DRzZK0CzWCl7Ai3Ue2G+p+4vkvzNJviRGpE6S+lhszP6b+PphJykG7jNH4kg+JzEA2j33++MH65/MHiPxPylap5iCRblW7WH74hAHxADkmhNWaOOMO1tL3AI84ECxLa1PK5Ek6MhYepDuN/Iwo+PvkZfr2NT5KmPeJtBkCXUMNz7jDDjVjVagjOcQotIp85pFRZFiRCqksGA3PSwHfB+kqjcW/k5BTKZhc5ygUwqqjlw63IKX0sPcj3tjL6WNj/1NGLyspUNCVz3KZ1R4mZ41AJbV9wnbb9MD/EQ/iEfqLqeNx5ltXlhZII6rlFm9DLLYE2uf2OKfxMY6Ahp579kxq2YCna65pOHTp9uQbecAPpyNZIhj6lkQ2mozosynkjCHOKjUSQF5xOk+AD59sU/07EoGoSfUMvf/AMhYzeuBCrm86OnqVuYbEjBJ4vA/qLbzLb3ARsOIM1qY0mnzSUyBbBgbE/h5xT+NruRc4HwIXRcQZxHEzx5vMrK1iCxFzgR4xQWJDn59iMaTjHNab7KeqldWIvZzb8PfDFUjZgNxbqEjjLMNbRfOsgJuQSenm+M3Fy1CM4qE5SZ+LK8ypyswkKKu669jgmVuVQFqrMmfi3MuWkctfIQoNrtcAeAO2KyLyoCEut1NP/Ls0/8AkN/9mJ6Z/MD+08oJWCIFgXCODqRjsvtjsBWHcxBu5MlUyxJHLJdbWsGsPYG2KFA1Fh6Xi5iyuzN6WeKONJUisQQGJCnxhq7BuZmycW4r1FNfxWcmIzSd2kijYRFDGWITf1EefGKbrUels1KZy/PPiRn2Y1DUOWalDsW1uNyL+O3bCeBJsmdbH4goM/xK7zs0qpmlrc5EVU8gSQSswa3nwcFyCmqmtcI4/wC2NSelrczpkFTTcRSc1TZ1Vj6V6FjbtbAkkmqivQW6dY0yzjvin5FYKXM1mEbEkFjqt2YnxgGxr/yjH8bHogS2Zb8Zcyyz5d62mBZR6JAbqTfe1uvTvhqgr0ZiyeGWNiXnKvjXlNcja6x4pXIBAGkb9SL/AI4BmPTTPlw5cO5esh4imqsvjElYKilICLIXGwBNhe+398MXYsTKS1URLFU5rVwQXqJCIImBRlsGUWsVPv4xAoPxGiyAIfFnNuavN2C6haS+o+Nr9vFsBXLQhG1NwpM6LSvT+rSIx6gQbk+P064JV4iTnuRx8SFaVJauPllWZQ2zXtfYjzt0wJVu5FzjowqHiaiqJkpxKbPGJVHYjxfAekxNw/VUGpPT8S0ssRn0TehdQULuR3IHX8cUfH+ZS+UCIAeLNRLRQIUO6kk3t2vgP4z/AJg/zR+DOLwxzusUhYIFJRrn+2NaqSLuZeRB5SSoihjaOIymJFftfv29+vfBBw3QhEn57M3SF54wAQZ7kXYWCre17dxi9MYpwCJTeP8A5jLstdxVxLdg3KI1K5A6jCshAjvGXkeNXOQUS1tZVy1LOGldidYT0t1v3wC8J6VT7BY11E2ZwVBrJOYWuht0tb6gYcvWo04vwZFFKI1susFhZ7HZh4wJBmhWQCq38xrlsOZ1M3KoqOR5kBPLiHr0qO4HYX64DIBVky18jERxIk7ZbW0kwkeMAISpVoyURvBPS+KGTjQkGHDkOmqfUVH/ABCeOFIEjllJWysdJPknsScE+QVZic2F8Y9xuXLhnPsyyBmyqeKXkBwp+0uoYbd9re+EjIFIPxOT5fg5HUss75w5Xx5rlafNyS1RNowxYkxSDpYeLY1ghvcs5Kc8ftfct2XUjicxyHm7IQdI6r5HTp7dMByA6jgGq5iSiJlkZ/t4y7NoDEAA2NvJG3Q9xiBuXUpQ5FmTtGsvNp4ERdZUllUqARY3G/1wfMAWZXp2dSbL6WIxrVGgCyU8hAYyEqQfvW7kYBshBkx4KP7guYUqzV4k1cllZSSDfRsdtPgk4NCa1E5VtuNTEUvF4jQR5fl7oFAVikdyOxN98FcMMPxKTBTa1B0MzHdEO23ewwra9fMBftt+4XmFBzLJoXVcBy53UX2v9cGFAlvxJGtzEuXQCVaNUmCtYFgLlRfcD8e2FAPV3IWU6AnPfitklOctlqqptDpqSMC/Yd8Rn2Lh+I7rmrq5yPLBVJecymCCoXQtlFrX379cI6crU9OCpAU0ag+dZG883zUdNLzNwxPpBAHW3bqMaAd66j0xqx5kxVPkwpkNqhXYWIuLC/cG/fAeuCaqal8U8SR1GdEFp4qapppKinchzzBKRd+hU23Hb88W1v7Zg9AqzUeo+oaWoqqVJ6ulQxyqPWSyvp/qG9iQRjOwVT3v8TOLv9yRstoKatCJyGiZFkMonK2bszX8/liixK8z+Zr9T22f8w2oop6uOJ2g0rIfSTJfXtuQQfbBFsfQ7iTlKodkx/wvxZX8LVHydaXanndNJbta1iL9D74FH9M0Jz/L8Y5E9VNH5norhXOaPiCgWtpVVZVG5drC/m+NiVxsTmBiTZjmnpoas6opBE5LIqkdSD0+uxwBSjcMPZ1PvkCpISolllPpL221dSDt4xZIAqRyR1PqamzJoIhMUVylnUjZGJ2O29v+cQqCZQckTWnoa2SY09fJE2pNMR03u4+8Tb2tbDaA6g8eRFw0ZUAAGR3I6sKiwPvbthdGN9onO81OigC09LEFpxZX5h3Hc+x6HC8X4HUVksCqkqFjSCSqrOW3LQPIWDAi9xYjcd8N66i0Y5SQ39oTl9DU/M8yI6UOqXRcEMCD/N5xAaU8oZQ/2inN+DaTMn+WzZDMk92dWYWVT227jY4IEEAxDK/IOOxOHceZTR8M5lQUWTiUQ0jErzQCVu19PuO+/nAYxbEtOn4mUuCHMY12SPWUEQWSITT6bSBRzZNiSD2vjH6iIf1NeN8gYcfiCTcEpTUbhaZpKmddMUUgBAJ9+5xR8g8vboTpHymagZGOEpaSE5TCEn5cjAxf+2Uc7i2ob2Bt1tbAJ5a3yqostkO3i+Onr4KBsuzWjqacPUSRidEukbdAHA6Kev1N8TgGYZMbWY6sfK0/xJF4ceKQUNTRSVEyMjGW5VJU8X6Ai3f++HY3LbOhFe1UP/X4lu4byCmqIGjjLSzD1hKh09LnoLDt7jC2tTYHfzEluS2YPnvCYeid2lMdQNgoUlUP9vywnmL5CDjtzTdRj8NeN83yOqTJcxmASNgVDNYOlx+GH4c4Y2nU53meOMbckGp3EZy9QrEo9GruAjg3RQT03OwP742iiNznEgg0Nx3DWT5PNHTzlHilF43Vd5Hbbr0tuDtuMC6g6EZgDAXGVJTSzSzRRsY72DFmB0udyAf5gP74OtAGFyHLULeB4Y2ljTnvBcFwoAYAX2PY/thfHeoSsasiDCsonGsNGA29jPuMDTS7T8Tk7VUiRshUDQdL2+6SP8/XEccNCBzN7+ZNDWaJFvChiLAk6RuBbqD9BgseVgNxbqurjykqVqXRjUBCzhnsBugO42/T8MXy1bR1DoT7MKWB5amriaQNEtw6i+2ki/Trg1YHQiTjFEnuedPjJSvQVUclXIJGqAjrJpIJv3sfqMAxIBmnwTxYXIeHc0jrYUzYlUSijWPcktqKgEgHYbX/ADxx/IztjpSO53sGFCSAe5c6TNKLMZaZaGaOeOL1SM49QUqTso2HS2LRrxsX1cAp6JZT3CeTH882bRq00XJZpJFF9J1XsPw84WMvLHR1K9IowECqKCkzGqeGR+WlQgLFeswtdDbyB0th4tVv5hYlCEsYzyOlgdJ6GpnM5VmdXO7dTYC/XCs6lSMgl4+LsQ0KzGCPK2imjjjYsQRZbalI7+bfngUzF9Qj4oHXUBq46bMHaWKVYaiUFlUNqVyB0KncD6/hjXxVE2Yt8eQE6nOsyStqKtoDTtBNDJYEC3oO1xfqMTGlElJlylanYOB6/imrPyHEFTJUtCEgSzgHSvTp1Pub43eMWP3TkZvivmdbokR6UQLRzVdCJ43SYHaNgL2I6jY2PjGriSeQiRSrVyyCmpVoilEGBml5rr0NyPHjv+GFEnkC0YCvGl7hVNkFUfl1dFMS3ks8hHt2HcXxbBT1L9zARVPUZuk0iJQnSrEDVGSbX7274Xw/cZc4b/EQVDTFXabYFtjb398Rib6mc5TqSwVFNNPJ9qLyMCBq222vb98QA1DtS5qNqWmXm/NBOXMVIbUCA/0PbEdRVQla2EZ1WYyZbAk08YkDemQDc27/AFwCqV1Leh2e5xT48ZZXZvTQV6stRohZfR94Rjpe3sf0xoQADUrBlX1OJ0PiV/gLh6lzX4d1tNEXjr5KhZCC27AKR08bYRmxK1NU1ZfK9LKKgWQ57Pk7nKBThZgWiLjuSdyfO3T3xhzqoTc72PCPIrIToy80metSRwUEd0EjmN42U2KgXNx+eELi9Ycj8RTsUsAEiQ19WsVRG0KhZKRtOkiwKndWv7XONa0PcR3Era6MsUE0E9hUPpBFkmB33t6W2sbX+uM7oGPcZjKqbvcjkGuJqapm1SxqXeJmtbsXAP4G18UmNcRpujGs5yG1+JW6ypnBmuFkrIoi8ciMLFfp+IwnNzw6XYM081ym+VQOHMhWVOWcSPHHVSwKaergJtq0+bdLjcY3+KCulnD8v2llvU9BcFUYrKCn4npaERKw01AVB9mt/TZv6ht9cdFFKizOS9seCmXbJswojmaoHjdUXmOhQkMD3uAd72+n0wQfVwDhBO5avmaGaqmmpqZRJKNtRAGw/v0wrIeXcaAp1Ujir5ERaV2McjqJAplAB7eOn6YBAW6h8qWpIVlb1PTMGO5GrviegfzB9X9Ty05WoBMU1iqAqbXuAd7/AKYYFI7MSCrnkJtT8x3jqlRDGATqsARvuCPN/wB8WFHZg4601RpPUVRSOleYNG3RidlXupXv2wAHHZjGynlQk75jFMrSTPJEkF1T0koPz6+2KWytmTI1ry+Ir/hwqfmIg8VS1REYQoIsNge/T++CAVdRSoRbAXcEoclXI6OsNLTI8kwaIQqAAht5/wCMFl6odxaLZt9zjGcUOccOcWUc+cUKGOpmXmf0EG29/NjjM+DmtEzv4vMK4/TXsR5xPzcn4xTK5KYsKsRyw8uS90Ybb369RjmqjYUKqdCdLxvJTLht5FmWcA1LQwxTFjrgkjLm677G/wCeH+M1rTGRgnfY0Y/p8zniiPJmcRThFlS1y21tSjt03xkfIcrlRqpFYIbcaMnzKqo6qlWriTlEEwyyGS4Lgb7eD4xnQZUBDbEc7pYA1E9DWvHNDPSSK1RGwkidCCbA9Le37YvxTkyOL6ET5iKByHUPnNFw/wAXUuYVMMklBm0a1REYtplBOqw7gG4+hx3cY9MbH9JxMv8A5WML1RnpThSeizTKhVUE4iy+tCssKG4Vu4PttfGo5AV3MSIy5CDGeU5RTwLzqGrAeKXUyk9wex7X/XAs9CMAazYj2jqeYiOYkicgxnoSBfb26+MBztZRS5NSs7PIZ3hUpr9RFiV62xWMn4kKjuBNm3GBJMD/AGZPouq309r7eMP4/uXX6nmKi4hf7FoYGaJyUkjI3vfqD3vhbBpnQkG41iq4IpF+Vja9gWR1Ft+1vI3BGKHVGGvtHt3DzJHVx/LQrGJiTJGXH3SP8O2GKR8yrrQEJpqpYouRVNGFe7yAjY2PQHpcb7YE4wdiM1XFjqEvBQrKJ4o0j0hPWrXuGF7363xTOqAXA4brGZpV5ZVOhqPRJHIxJudJDf1fliiSO4a4uQsSr8S8N0lbSwUeY0kVQzOGc302JuBY9uxGDWzEWcZNdzlvH8FXRZhS5rTyzu+XMiRK5BPLBvpv3sR3wj0RZubvByMAVeL4P4rnnHFZTU4iaJnFc4jjseWNzp/A9MJXCvHmRudP+cFw0JaOI6PiHhX/ANVSAVFHJEHBv6lVuxHjcYx5vpoccrIMT431AOODia8HZumYcNVuX1tGJZppRNH6hddN77f53w9cPpAYwNSeflN816i/hCFqTiE1stK+qGpUaG3BjF9Sn67Y1pgKD2TN5PkjLjC3O1Z3kWRZ1NluYU32UcTa44+XbSDu599gMaAnI2ZiBKj2nuWXJcso+HQk2Vy1MdHVqJDoJKEn/b1BBxZKH2juES3GyZb46ikkcvA6IspVHCyNqLkX3Hb67dd8KIY9iEmW1Elqs2y+BRJAs9O5AiRyDul9yRvex74WRuvzDDg6Ehp6wM1RBT1c1RrQus7sUTU217n+2GKCGqA3EiyZBGXCKGy4SGwu4qns3v8Ae74fZgWv7nnKN5pKsRUyNGVbVq3NtuhwPLRuZMQWw19xlTzOqmRmYadmLMTbfqP++xwkgA2IaE3fwYatdGZY4qmdOaRdTfp7/wCe+GAi9wha6G4wn5Jjcy3UrcRgtazDe4/C+Jyq2lcCRZjSglWSCORr6THYHUd/BwH3dx60oASHpNqjSiZyVDWJQ2ut+t/bAqQTZ+IZBbQMW19E2dV71UVSpjhtHots9jv/AIcECE2fmLdeRsdCI6zhyJ6aWGShQRuzEuTuVB2P674av5mb0nUkqdGJKbgqOkz/AC/OactTsFWLXCbBorEEk+464hIAJ7hjMUIxgdy31+SUWe5W2V1NU6FmIgZV/l9v0xD71siUnLmdyhcOfD+poc3mdai1IxYqZF2t7Hvv+mCC6siObM2VeBEttDlkQqqmaanWWqYDUoAUbfzEYYKqJsoaM6DSJAKMRNalUHQkjIZA5O4AI3HcYSTuzHlFaiJjK6megzaBoKZ1ppIzz3IvZwbAqp7/ALg4D7jctQPt7MeVVOzo5gqo3NSbuvL9UZtcH2v4xfxuMFDVVNZnmEdPy5yBCbyGRiWNyBpA98CVWri2LBtTariesqebSK4NEsdQghbe2o/eHQ2Iv7WOKalomWFPQgLcSZezFjWlSTfTrG3t0wXMyFcgnCKavlq6sRw60JX1HswBv1HfFhhXumQcn6PUcqYZqmopZqiNJIl6Wurg+/TvgQByu4wpZ0KhFdRxVFNHPCyDkICp0+oHob7YJutSE+noT5BHV5fHK8oJXSCvv0v9cACVAEX7clUYTT1aUCx0zTCVXFkfqImv5HY4Ik0IQr7blyy6JJ6QpIlpFUGORVvq6jc4AC+5rAAFSfKctsjxy04hlfUHsos3uMEyS1ANgzSroYyrUbylBay2O7AH9cQ2JTKvUX1mSznL0BjLMCbBbBg1j+WBDAG4LJzANdSXJoG3zGeMD+QIt7qBt07YNjq4KKT7mkUFR8nVxyfLKaZ2fUwQkjvffxcA4gZiakWrO5mgo53rPnFKyxITC3LPrVL7H+3uMMu9QUGyY8iqKwzSx1hWKHUCIgNV1A2e/gntiuvuMYGqmk1Bz/lTPFIrIbPIji9yP6L/ALYWSsYQyix8xoksSysvIZXeK6tqshHcXJ9xgwuoBblr5i6cVFQ1FK1QsSM7JPyj6ltv6vp5GKVV7kyFuPt7ms8FRQZvDM9UjQKmlWhbqD2cHob7/X64ohSIoeoGswCXIqeWV5TQltbFrh7XuetrbYIED4jK/c4nIJvmIpzEeSx0sI7C3+4jv9R5wWiNzAuOzbAzNYzwzSclHSdo7yEG4kW+5t5GKCgihJkLV7RHtJXyHK6etmqlMSlUTUpU6ri6keLW9jiiIw5clVVyCOZZauVaYrG0j25VrhT1sL9r4WVLQRd3UY/LxCtlp1WSEAEq999vvLvt3O1+2JxPUIO9EgRpkfE9Xl4o8uzCnlJjlYu6C6NCdrE9v+cX2Yfj5CFpu5caXP4ngirYqR5wNkKsLab2ufyxdHozSuTjM1VZSVMtPO9wryctfSSxJ6qbePOIqV3IcltsQyrlgjeGF4R9oHRTfTpIHQe/fFnvqQPV1E2aVdRTQsIJSeXLdpY1Chr7gXtuCLgnyME2xqKbIwY31Cv4RNmXD4monLxH7SIxkcwX2JcX6YWzADcZ6fJTx6MAyVhlObTxVhVW0AMFuFZbA3I89cEDqxAUBG4VqN0NMqVFVl5gUPHrCOT+Qv12xTaG5RIBIHUOleBaamkmjaN4gdfquCrfdIA6b9ziUF7hhzxsRdFVVWaZU9WKjT6ikg5frC3AsB336nfrhimh1Flyzf0geRNHmGY1kOv5eaCNUiptTaQALMbD3t/xgBtY1X5NQjanyhZnpqcqtowI5Vc7gqCQ9/yxDQ3IOTin2YT/AAyvGxFMSP8Ae+B9QQfRP5nmfIc/hrKSCppXE0J6qTZ0YdVw5RyJBg5VfE3ulrgiV2iq41jfWl3I+9b64Ee0UILI7foRr/DKRKOSSKmLRS2LBDb33XuOxwl8pDcahp4y0aM1q6GZ4KdqEqrQr2sHA9z38YYP0YvKtNN44KrMolSKQhQAVVk9TODtfzcnr12xVFrqUQpFfEmSaHmQZXW0TJJANfNiOzLf32//AHFBiv3Sv6Qqhz0ZYwo4XYwUrugljhJDLf0q3Ybk2ODAvcM5Ao/csmR51RQ5n8yIRKczjUnUwBjdRYi3nBKxBqDiChybubcTRoscpjpjIkbCQhXJKnYGx7Ei31wohjQMY7gi1g0khoI4GpYWWlFjIrHVqVje3S9/FsTkyt1KYrXE/MsmUVDUVa1O1kXkmUWUDVHbYi5t7fhi6VtmNT/apRBMzpchzCpkc1LpJItoyAPS+nUAfI64i0BqCyMxJiXL0irlooFrC81NOsbu0NkSE7lja/Q2A/thiqp+6Ie1YAdzNbyc04kjiFYgijQB1LFQ9uqg/r/3gR8iMZm5ASwwRwxxw5VVU8dOkWsrJHMbBHJsTfY9B798WSeoPJbof3gS0dXT8SU+YUZRo2WzuhLCQ6egFtjbv0xTkj2wlsPfYljligGVVmawPFzXJAEp9eroV2+v6YFlsCNXld1M0/D0c9PFO1DlwMiK5Bm6XF/GGDj+YJbJ+J4Py/OqnhnNEkteCaQCdLb3/qGDCgtrubsqLkomdhyjMkniakedbyXdT01IRe4wsoR2JysjZApjikzg5dTcwylkNkaxvv8A99MCakw52A3/AIjaCrirIxyG9JGqxsNQ8XwCopMtmOi/5muWVENRByI31Sx3udxqIPtsDiDZNQvUQngvcOSsJs7Ilo1aNze4Cne+KB5CjD9xNfMJy541rJDTUa6pFSMgH7w8n/N7YNi2gZSqrsSR1GsnD0NROqmpGuVuaFA9Ckdree34YZY6MHJiYEVI3rknzh1GtqlZFCKY/uqBuv4EX384EmjQl5MWuTQ2rSsnn+frirxARxmIhRZAD43wtV5nZhZgVpjsQVUqczjNTNUNG0ZMIQx3+zO+kHuO/vgvTX4iy7uNQ6GkT7KmqgoWnpnmWEWAItsbedrW7YM9Q05dNFKTU3JooKASid5Spck6AGb7p/PYYD7uoANnXc0zJ8wyyOZ6MQpUqWj1EgMQxsxC+cWrUYvKnEchLFl+arWZPC1RVRVD0aqKlSo1OgJtv36DF86JjRjUp/3ARXwVUSyRUVaKZpFjjdRYgavUthsbi+BAY/d8yAAADHLTkcK5tRnJlRIUpZBJaVfW6Ekg37kj/N8WRXc0La6XuaSZdlrSM0cFWELEqCo6du2L9sXa/wDtPIfxP4ISgqXr4oiIJrujKdka+49sdDLiK+8CbkcsOLdiJ+E84q0hCO7F6c6barnT5+nbGajuZsw/InRqSrWaiR4yG1yLqib7rAjz5GEldzCoAvvUaZe4moGpaeE+mxQK/rHe34YFqGzKB5r1J8izBMvlf5qR3IOpU+6dX+fviOFVdfMgJxbYauW+pkpJIRnFOoPPAD6VFtxve2EoKA3NuV1PuMST5xLFOBR1hjuVUllH3b7fhf8AfDDZ6OplDirBliyxWq6SRDmASYMHHKf1arWKke9xgyVqhLtmFCBVNDVZdmSmZ6qIzjUpdgwva5BI9x5wNVGGwdw+lNRmVJ8xUyslRE1uQL2Zelj5+vvgigO5QfnHWR01XJAI1SQSRR6eW+zXufTfx4tgSQnccifEDPzJzGQTQVdLNEnpRkJLeb/53wsZPU1IQMTbkzZpTRQwZXVqszGzxqsYAkUtbaw6j+2DskWshplubvzYKhsvMU0iTgWDqCYd9mHvv1vgkHzEZOgpGo1TJqSmEhiBVAjRFSoKEncE+cQOCdxqpwWh1GtJl2W0FOJjC8bPIsihZPQpuLbHa/X88QZLNQxhAXR1Gg+VWIVKRGnaNbScs/eGBJZhR3L4DRi6Sqp2kZhl1QQSSDzwL4nGor01nGs3ymkzmgny6tp1aN1IJ62J7jHocqkpxPxJjdg085cTZXV8K529PEwVkYgWOzJ4OOURTVN+Q88didF4QqYczpFpeYbyxBoja116aT9MJcBZzuJc0THeVyS5fmyRXa6N6Df+XrvgOJyfEQyeiRRuOc+pIqiohrkUNzVN0O12tthK0DTSZ+RIMzwzX1EivQifTzZAmm3pFh0t+HXDQqiWjFwVuF1+XyCrLF45UawMYXufF+nTF2tVI2OgFPzJssrWoKklKciVRolXVq3/ANpOBRgwoQ2BwEalu+aaSNWjYTwqbPrBN1+h9sWpI0Yx35bhzZU7R09PBGscdzpI6qCNhi75bh+j8iNsslMc6RmZldHZHHi3TfvgMmMHccmQqeMYTQGqEjG76kvuR6lHX9u/nC8WEYfcPmMyZPUUqR1KhBSVFO71EdLGHjXmwuzk2S+627f94c1IKmJfcQ3zMUuawUsP8XSCQPK/JkIcXRr9j3HtiuVDqEwBNmWfLoa2uoKc1iLIRLpBVguruG6dbYoAsLjCpeiDGQnpo5VopqZgpJBZn1EHCiwJ18RvBkWzNErIaqtSjo6mSOJ1+XYMtxq23/XDMQF8vmAbIuIZs0oYJpIDWxfZsU3pz2NvGH6/EqjP/9k="

/***/ }),

/***/ "Aqhm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.keyListener = this.onKeyDown.bind(this);
    window.addEventListener('keydown', this.keyListener);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('keydown', this.keyListener);
  },

  methods: {
    onKeyDown: function onKeyDown(event) {
      if (event.key === 'ArrowLeft') {
        this.$emit('moveLeft');
      } else if (event.key === 'ArrowRight') {
        this.$emit('moveRight');
      } else if (event.key === 'Escape') {
        this.$emit('close');
      }
    }
  },
  props: ['piece', 'urlPrefix'],
  data: function data() {
    return {
      keyListener: null
    };
  }
});

/***/ }),

/***/ "D+VX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_auth__ = __webpack_require__("Pfph");


var _mutations;




var initialState = {
  authToken: localStorage.getItem('token'),
  loggingIn: false,
  notifications: []
};

var actions = {
  login: function login(_ref, _ref2) {
    var commit = _ref.commit,
        state = _ref.state;
    var username = _ref2.username,
        password = _ref2.password;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* LOGIN */]);
    __WEBPACK_IMPORTED_MODULE_2__api_auth__["a" /* default */].login({ username: username, password: password }).then(function (response) {
      if (response.data.token) {
        var token = response.data.token;
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* LOGIN_SUCCESS */], { token: token });
      } else {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* LOGIN_FAILURE */], { error: 'Unrecognized api error. Please try again later or notify the webmaster.' });
      }
    }, function (error) {
      if (error.response.status === 401) {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* LOGIN_FAILURE */], { error: 'Invalid username or password.' });
      } else {
        commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* LOGIN_FAILURE */], { error: 'There was an error contacting the server. Please try again later.' });
      }
    });
  },
  logout: function logout(_ref3) {
    var commit = _ref3.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* LOGOUT */]);
  },
  clearNotifications: function clearNotifications(_ref4) {
    var commit = _ref4.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* CLEAR_AUTH_NOTIFICATIONS */]);
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* LOGIN */], function (state) {
  state.loggingIn = true;
  state.loginError = null;
  state.notifications = [];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* LOGIN_SUCCESS */], function (state, _ref5) {
  var token = _ref5.token;

  localStorage.setItem('token', token);
  state.loggingIn = false;
  state.authToken = token;
  state.loginError = null;
  state.notifications = [{
    message: 'Logged in.', type: 'success'
  }];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["f" /* LOGIN_FAILURE */], function (state, _ref6) {
  var error = _ref6.error;

  state.loggingIn = false;
  state.authToken = null;
  state.notifications = [{
    message: error, type: 'error'
  }];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["g" /* LOGOUT */], function (state) {
  localStorage.removeItem('token');
  state.authToken = null;
  state.loggingIn = false;
  state.notifications = [{
    message: 'Logged out.', type: 'success'
  }];
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["h" /* CLEAR_AUTH_NOTIFICATIONS */], function (state) {
  state.notifications = [];
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: initialState,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "Drc2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'navbar'
});

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGIN_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LOGIN_FAILURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOGOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return CLEAR_AUTH_NOTIFICATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FETCH_GALLERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FETCH_GALLERY_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FETCH_GALLERY_FAILURE; });
/* unused harmony export FETCH_ASSET_INDEX */
/* unused harmony export FETCH_ABOUT_CONFIG */
/* unused harmony export UPDATE_GALLERY_CONFIG */
var LOGIN = 'LOGIN';
var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
var LOGIN_FAILURE = 'LOGIN_FAILURE';
var LOGOUT = 'LOGOUT';
var CLEAR_AUTH_NOTIFICATIONS = 'CLEAR_AUTH_NOTIFICATIONS';
var FETCH_GALLERY = 'FETCH_GALLERY';
var FETCH_GALLERY_SUCCESS = 'FETCH_GALLERY_SUCCESS';
var FETCH_GALLERY_FAILURE = 'FETCH_GALLERY_FAILURE';
var FETCH_ASSET_INDEX = 'FETCH_ASSET_INDEX';
var FETCH_ABOUT_CONFIG = 'FETCH_ABOUT_CONFIG';
var UPDATE_GALLERY_CONFIG = 'UPDATE_GALLERY_CONFIG';

/***/ }),

/***/ "FnhZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__ = __webpack_require__("/oiM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a11f3064_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__ = __webpack_require__("zYR8");
function injectStyle (ssrContext) {
  __webpack_require__("VvLp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a11f3064"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Contact_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a11f3064_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Contact_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HKjq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Piece__ = __webpack_require__("82Oe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var piecesUrl = 'https://s3.amazonaws.com/marcia-pottery/pieces.json';

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    piece: __WEBPACK_IMPORTED_MODULE_3__Piece__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])({
    token: function token(state) {
      return state.auth.authToken;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])([]), {
    selectPiece: function selectPiece(sectionIndex, pieceIndex) {
      this.selected = {
        section: sectionIndex,
        piece: pieceIndex
      };
    },
    onMoveLeft: function onMoveLeft() {
      if (this.selected.piece > 0) {
        this.selected = {
          section: this.selected.section,
          piece: this.selected.piece - 1
        };
      } else if (this.selected.section > 0) {
        var section = this.selected.section - 1;
        this.selected = {
          section: section,
          piece: this.sections[section].pieces.length - 1
        };
      }
    },
    onMoveRight: function onMoveRight() {
      if (this.selected.piece < this.sections[this.selected.section].pieces.length - 1) {
        this.selected = {
          section: this.selected.section,
          piece: this.selected.piece + 1
        };
      } else if (this.selected.section < this.sections.length - 1) {
        this.selected = {
          section: this.selected.section + 1,
          piece: 0
        };
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: piecesUrl
    }).then(function (res) {
      _this.sections = res.data.sections;
    });
  },
  data: function data() {
    return {
      keyListener: null,
      selected: null,
      imgPrefix: 'https://s3.amazonaws.com/marcia-pottery/images/',
      sections: []
    };
  }
});

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__getters__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_auth__ = __webpack_require__("D+VX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_gallery__ = __webpack_require__("aTZx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_about__ = __webpack_require__("Ke/w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_about___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__modules_about__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_4__modules_auth__["a" /* default */],
    gallery: __WEBPACK_IMPORTED_MODULE_5__modules_gallery__["a" /* default */],
    about: __WEBPACK_IMPORTED_MODULE_6__modules_about___default.a
  },
  strict: debug
});
if (false) {
  module.hot.accept(['./actions', './getters', './modules/auth', './modules/gallery', './modules/about'], function () {
    /* eslint-dsable */
    var newActions = require('./actions').default;
    var newGetters = require('./getters').default;
    var newAuth = require('./modules/auth').default;
    var newGallery = require('./modules/gallery').default;
    var newAbout = require('./modules/about').default;
    /* eslint-enable */
    store.hotUpdate({
      actions: newActions,
      getters: newGetters,
      modules: {
        auth: newAuth,
        gallery: newGallery,
        about: newAbout
      }
    });
  });
}/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ "KRro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "piece-tile"
  }, [_c('div', {
    staticClass: "thumb-container"
  }, [_c('img', {
    staticClass: "thumb",
    attrs: {
      "src": _vm.imgPrefix + _vm.piece.url
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "thumb-hover icon-zoom-in"
  })]), _vm._v(" "), _c('div', {
    staticClass: "piece-data"
  }, [_c('div', {
    staticClass: "piece-label"
  }, [_vm._v(_vm._s(_vm.piece.label))]), _vm._v(" "), _c('div', {
    staticClass: "piece-size"
  }, [_vm._v(_vm._s(_vm.piece.size))])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ke/w":
/***/ (function(module, exports) {



/***/ }),

/***/ "Lbbx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("iaho");
function injectStyle (ssrContext) {
  __webpack_require__("dyZs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bd26cd6c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__("gyMJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__("bGai");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Navbar__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Modal__ = __webpack_require__("/o5o");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







// Component imports



// Component registration
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('navbar', __WEBPACK_IMPORTED_MODULE_6__components_Navbar__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('modal', __WEBPACK_IMPORTED_MODULE_7__components_Modal__["a" /* default */]);

// Vue initialization
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  components: __WEBPACK_IMPORTED_MODULE_5__components__["a" /* default */],
  api: __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
});

/***/ }),

/***/ "Pfph":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(_ref) {
    var username = _ref.username,
        password = _ref.password;

    return __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].axios.post('https://9pt0wza7da.execute-api.us-east-1.amazonaws.com/development/login', {
      username: username,
      password: password
    });
  }
});

/***/ }),

/***/ "RHrI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about_1.0e6be14.jpg";

/***/ }),

/***/ "TfjL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tkgu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about_4.f8fd791.jpg";

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports) {



/***/ }),

/***/ "VvLp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_About__ = __webpack_require__("c27y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Gallery__ = __webpack_require__("sl25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_GalleryEdit__ = __webpack_require__("wFC2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Contact__ = __webpack_require__("FnhZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Login__ = __webpack_require__("xJsL");








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: {
      name: 'About'
    }
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_2__components_About__["a" /* default */]
  }, {
    path: '/gallery',
    name: 'Gallery',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Gallery__["a" /* default */]
  }, {
    path: '/edit-gallery',
    name: 'Edit Gallery',
    component: __WEBPACK_IMPORTED_MODULE_4__components_GalleryEdit__["a" /* default */]
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Contact__["a" /* default */]
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Login__["a" /* default */]
  }, {
    path: '/*',
    redirect: {
      name: 'About'
    }
  }]
}));

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'landing'
});

/***/ }),

/***/ "aTZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_gallery__ = __webpack_require__("5asW");


var _mutations;




var initialState = {
  selected: {
    type: Object,
    default: null
  },
  pieces: {
    type: Object,
    default: null
  },
  fetching: {
    type: Boolean,
    default: false
  },
  fetchError: {
    type: Object,
    default: null
  }
};

var actions = {
  fetch: function fetch(_ref) {
    var commit = _ref.commit;

    commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FETCH_GALLERY */]);
    __WEBPACK_IMPORTED_MODULE_2__api_gallery__["a" /* default */].fetch().then(function (response) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* FETCH_GALLERY_SUCCESS */], { data: response.data });
    }, function (error) {
      commit(__WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* FETCH_GALLERY_FAILURE */], { error: error });
    });
  }
};

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* FETCH_GALLERY */], function (state) {
  state.fetching = true;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* FETCH_GALLERY_SUCCESS */], function (state, _ref2) {
  var data = _ref2.data;

  state.sections = data.sections;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* FETCH_GALLERY_FAILURE */], function (state, _ref3) {
  var error = _ref3.error;

  state.fetching = false;
  state.fetchError = error;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: initialState,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ "bGai":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navbar__ = __webpack_require__("lfLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Modal__ = __webpack_require__("/o5o");



/* harmony default export */ __webpack_exports__["a"] = ({
  Navbar: __WEBPACK_IMPORTED_MODULE_0__Navbar__["a" /* default */],
  Modal: __WEBPACK_IMPORTED_MODULE_1__Modal__["a" /* default */]
});

/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3af938a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("qA7t");
function injectStyle (ssrContext) {
  __webpack_require__("rHIF")
  __webpack_require__("ecvH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d3af938a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3af938a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dyZs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ecvH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ey46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-section"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("Marcia Halperin Pottery")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item ",
    attrs: {
      "to": "/gallery"
    }
  }, [_vm._v("Gallery")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-section"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fN3O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "section-container"
  }, _vm._l((_vm.sections), function(section, sectionIndex) {
    return _c('div', {
      key: section.title,
      staticClass: "section"
    }, [_c('h3', {
      staticClass: "section-title",
      attrs: {
        "id": section.title
      }
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('div', {
      staticClass: "piece-list"
    }, _vm._l((section.pieces), function(piece, pieceIndex) {
      return _c('piece', {
        key: piece.url,
        attrs: {
          "piece": piece,
          "img-prefix": _vm.imgPrefix
        },
        nativeOn: {
          "click": function($event) {
            _vm.selectPiece(sectionIndex, pieceIndex)
          }
        }
      })
    }))])
  })), _vm._v(" "), (_vm.selected) ? _c('modal', {
    attrs: {
      "urlPrefix": _vm.imgPrefix,
      "piece": _vm.sections[_vm.selected.section].pieces[_vm.selected.piece]
    },
    on: {
      "close": function($event) {
        _vm.selected = null
      }
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gyMJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios__ = __webpack_require__("Rf8U");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__("Pfph");






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_1_axios___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  auth: __WEBPACK_IMPORTED_MODULE_3__auth__["a" /* default */]
});

/***/ }),

/***/ "iaho":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ibNe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [(!_vm.token) ? _c('form', {
    staticClass: "login-form",
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.formSubmit($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "login-input",
    attrs: {
      "type": "text",
      "placeholder": "username",
      "disabled": _vm.loggingIn
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "login-input",
    attrs: {
      "type": "password",
      "placeholder": "password",
      "disabled": _vm.loggingIn
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('router-link', {
    staticClass: "subtle-link",
    attrs: {
      "to": "/password-reset"
    }
  }, [_vm._v("Trouble logging in?")]), _vm._v(" "), _c('button', {
    staticClass: "login-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.login({
          username: _vm.username,
          password: _vm.password
        })
      }
    }
  }, [_vm._v("\n        Log In\n      ")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.token) ? _c('div', {
    staticClass: "login-form"
  }, [_vm._v("\n    " + _vm._s(_vm.token) + "\n    You are logged in.\n    "), _c('div', {
    staticClass: "form-actions"
  }, [_c('router-link', {
    staticClass: "subtle-link",
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('button', {
    staticClass: "login-button",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Log Out")])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.notifications), function(notification) {
    return _c('div', {
      key: notification.message,
      staticClass: "login-message",
      class: {
        error: notification.type === 'error'
      }
    }, [_vm._v("\n    " + _vm._s(notification.message) + "\n    "), _c('button', {
      staticClass: "close-button",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.clearNotifications()
        }
      }
    }, [_vm._v("x")])])
  })], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "imYJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lfLh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__("Drc2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60cfaa5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__("ey46");
function injectStyle (ssrContext) {
  __webpack_require__("9CZf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60cfaa5c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60cfaa5c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mUbh":
/***/ (function(module, exports) {



/***/ }),

/***/ "nKb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['login', 'logout', 'clearNotifications']), {
    formSubmit: function formSubmit() {
      this.login({ username: this.username, password: this.password });
    }
  }),
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapState */])({
    loggingIn: function loggingIn(state) {
      return state.auth.loggingIn;
    },
    token: function token(state) {
      return state.auth.authToken;
    },
    notifications: function notifications(state) {
      return state.auth.notifications;
    }
  }),
  data: function data() {
    return {
      username: null,
      password: null
    };
  }
});

/***/ }),

/***/ "nkxT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qA7t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('navbar'), _vm._v(" "), _vm._m(0)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "examples"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("RHrI")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__("seMi")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__("us6F")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__("Tkgu")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__("Aaqe")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "about-text"
  }, [_c('div', [_vm._v("\n          I create both functional and one of a kind sculptural ceramic work.\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          In my functional work my intent is to create pots that are not only functional\n          but also invite the user to touch and use these pieces.\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          I frequently manipulate the surface of a piece when it is still wet to capture\n          a moment in the life of the clay and to alter and enhance the form both visually and\n          functionally.\n        ")]), _vm._v(" "), _c('div', [_vm._v("\n          My work is inspired by nature, primarily the colors of the sea, sky, sand and\n          soft light that is frequent on the island of Martha’s Vineyard,  and influences by Cynthia\n          Bringle and Warren Mckenzie with whom I have studied.\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qrmn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-mask",
    attrs: {
      "title": "Close Image"
    },
    on: {
      "keyDown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        _vm.$emit('moveLeft')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "right", 39)) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        _vm.$emit('moveRight')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27)) { return null; }
        _vm.$emit('close')
      }],
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "title": ""
    }
  }, [_c('button', {
    staticClass: "close-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "modal-img",
    attrs: {
      "title": _vm.piece.label,
      "alt": _vm.piece.label,
      "src": _vm.urlPrefix + _vm.piece.url
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "direction-button left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('moveLeft')
      }
    }
  }, [_vm._v("\n          Previous\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "direction-button right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$emit('moveRight')
      }
    }
  }, [_vm._v("\n          Next\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-text"
  }, [_vm._v("\n        " + _vm._s(_vm.piece.label) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-text"
  }, [_vm._v("\n        " + _vm._s(_vm.piece.size) + "\n      ")])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rHIF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "sHLA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "seMi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about_2.1159a03.jpg";

/***/ }),

/***/ "sl25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__("HKjq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce4d200_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__("x2uO");
function injectStyle (ssrContext) {
  __webpack_require__("nkxT")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2ce4d200"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ce4d200_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t4ux":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Piece__ = __webpack_require__("82Oe");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var piecesUrl = 'https://s3.amazonaws.com/marcia-pottery/pieces.json';
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    piece: __WEBPACK_IMPORTED_MODULE_3__Piece__["a" /* default */]
  },
  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapState */])({
    token: function token(state) {
      return state.auth.authToken;
    }
  }),
  data: function data() {
    return {
      selected: null,
      imgPrefix: 'https://s3.amazonaws.com/marcia-pottery/images/',
      sections: []
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])([]), {
    selectPiece: function selectPiece(sectionIndex, pieceIndex) {
      this.selected = {
        section: sectionIndex,
        piece: pieceIndex
      };
    }
  }),
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1_axios___default()({
      method: 'get',
      url: piecesUrl
    }).then(function (res) {
      // console.log(res);
      _this.sections = res.data.sections;
    });
  }
});

/***/ }),

/***/ "us6F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/about_3.fb5ee21.jpg";

/***/ }),

/***/ "vrgC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['piece', 'imgPrefix']
});

/***/ }),

/***/ "wFC2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryEdit_vue__ = __webpack_require__("t4ux");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a69b2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryEdit_vue__ = __webpack_require__("fN3O");
function injectStyle (ssrContext) {
  __webpack_require__("Lbbx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33a69b2a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GalleryEdit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a69b2a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_GalleryEdit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x2uO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "sidenav"
  }, _vm._l((_vm.sections), function(section, index) {
    return _c('div', {
      key: section.title,
      staticClass: "sidenav-item"
    }, [_c('a', {
      attrs: {
        "href": '#' + section.title
      }
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), (index < (_vm.sections.length - 1)) ? _c('div', {
      staticClass: "dot"
    }) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.token) ? _c('router-link', {
    staticClass: "edit-button",
    attrs: {
      "to": "/edit-gallery"
    }
  }, [_vm._v("Edit Gallery")]) : _vm._e(), _vm._v(" "), _c('h2', [_vm._v("Pieces by Marcia Halperin")]), _vm._v(" "), _c('div', {
    staticClass: "section-container"
  }, _vm._l((_vm.sections), function(section, sectionIndex) {
    return _c('div', {
      key: section.title,
      staticClass: "section"
    }, [_c('h3', {
      staticClass: "section-title",
      attrs: {
        "id": section.title
      }
    }, [_vm._v(_vm._s(section.title))]), _vm._v(" "), _c('div', {
      staticClass: "piece-list"
    }, _vm._l((section.pieces), function(piece, pieceIndex) {
      return _c('piece', {
        key: piece.url,
        attrs: {
          "piece": piece,
          "img-prefix": _vm.imgPrefix
        },
        nativeOn: {
          "click": function($event) {
            _vm.selectPiece(sectionIndex, pieceIndex)
          }
        }
      })
    }))])
  }))], 1), _vm._v(" "), (_vm.selected) ? _c('modal', {
    attrs: {
      "urlPrefix": _vm.imgPrefix,
      "piece": _vm.sections[_vm.selected.section].pieces[_vm.selected.piece]
    },
    on: {
      "close": function($event) {
        _vm.selected = null
      },
      "moveLeft": function($event) {
        _vm.onMoveLeft()
      },
      "moveRight": function($event) {
        _vm.onMoveRight()
      }
    }
  }) : _vm._e()], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xJsL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("nKb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f87b417_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("ibNe");
function injectStyle (ssrContext) {
  __webpack_require__("sHLA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f87b417"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f87b417_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zYR8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar'), _vm._v(" "), _vm._m(0)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_vm._v("\n    For more information and prices: "), _c('br'), _vm._v("\n    Email "), _c('a', {
    attrs: {
      "href": "mailto:marciahalperinpottery@gmail.com"
    }
  }, [_vm._v("marciahalperinpottery@gmail.com")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.827eedd83132c202e6ee.js